import React, { useEffect } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import AdminLayout from "layouts/Admin.js";
import Login from "components/login/Login";
import Forgotpassword from "components/login/Forgotpassword";
import Enterdigitcode from "components/login/Enterdigitcode";
import Createnewpassword from "components/login/Createnewpassword";
import Signup from "components/login/Signup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useEagerConnect from "./hooks/useEagerConnect";

function App() {
  useEagerConnect();
  return (
    <>
      <ToastContainer
        autoClose={5000}
        style={{ fontSize: 12, fontWeight: 300 }}
        theme="light"
        position="top-right"
      />
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route path="/user" component={AdminLayout} />
          <Route path="/forgotpassword" component={Forgotpassword} />
          <Route path="/enterdigitcode" component={Enterdigitcode} />
          <Route path="/createnewpassword" component={Createnewpassword} />
          <Route path="/signup" component={Signup} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
